import { DataSetSection, IDataSetSection } from './DataSetSection';
import { IConfiguration } from '@/models/configuration/Configuration';
import { DataSetEditor } from './DataSetEditor';
import { DataSetMyMillInformation, IDataSetMyMillInformation } from './DataSetMyMillInformation';

export interface IDataSetBase {
    id?: number;
    dataSetId?: string;
    sections: IDataSetSection[];

    created: DataSetEditor;
    lastModified?: DataSetEditor;
    myMillImport?: IDataSetMyMillInformation;
}

export class DataSetBase implements IDataSetBase {
    public sections: DataSetSection[];
    public id?: number;
    public dataSetId?: string;
    public created: DataSetEditor;
    public lastModified?: DataSetEditor;
    public myMillImport?: DataSetMyMillInformation;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IDataSetBase, meta?: { timestamp?: number });
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IConfiguration, meta?: { timestamp?: number });
    constructor(obj?: any, meta?: { timestamp?: number }) {
        // do not set id to undefined or dexie.js will throw an error
        if (obj && obj.id != null) {
            this.id = obj.id;
        }

        if (obj && obj.dataSetId != null) {
            this.dataSetId = obj.dataSetId;
        }

        this.sections = [];
        if (obj && obj.sections !== undefined) {
            obj.sections.forEach((section: any) => {
                this.sections.push(new DataSetSection(section));
            });
        }

        if (obj && obj.created) {
            this.created = new DataSetEditor(obj.created);
        } else {
            this.created = new DataSetEditor({
                date: new Date().toISOString(),
                userName: 'unknown',
                userId: '0',
                userEmail: 'unknown',
            });
        }

        if (obj && obj.lastModified) {
            this.lastModified = new DataSetEditor(obj.lastModified);
        }

        if (obj && obj.myMillImport) {
            this.myMillImport = new DataSetMyMillInformation(obj.myMillImport);
        }
    }
}
